export type PagamentoType = {
  id?: number;
  nome: string;
  tipo: string;
  parcelas: number;
  ativo: boolean;
};

export const pagamentoDefaultValues = {
  id: undefined,
  nome: " ",
  tipo: " ",
  parcelas: 0,
  ativo: true,
};

export enum TipoPagamento {
  Dinheiro = "Dinheiro",
  Cartao = "Cartão",
  Pix = "Pix",
  Boleto = "Boleto",
  Cheque = "Cheque",
  Outros = "Outros"
}
